export { default as AdminRoutes } from './AdminRoutes';
